import { z } from 'zod'
import { FetchedInventory } from '~/features/hooks/useGetInventory'
import { Visitor } from '~/supabase/types'
import { storeLocations } from '~/utils/constants'

export const visitorFormSchema = (
  z.object({
    info: z.string().min(1).nullable(),
    pax: z.coerce.number().min(1, { message: 'Invalid number' }),
    agency: z.string().min(1),
    employee: z.string().min(1),
    total: z.coerce.number().superRefine((val, ctx) => {
      const match = val.toString().match(/[^0-9]/)

      if (match)
        ctx.addIssue({
          code: 'custom',
          message: 'Make sure you write down only numbers, no commas or decimals.',
        })
    }),
    country: z.string(),
    products: z
      .array(z.string())
      .nullable()
      .transform((data) => {
        if (Array.isArray(data) && data.length > 0) return data
        return null
      }),
    product_ids: z
      .array(z.string())
      .nullable()
      .transform((data) => {
        if (Array.isArray(data) && data.length > 0) return data
        return null
      }),
    payment_type: z.string().nullable(),
    created_at: z.string(),
    store: z.enum(storeLocations),
    message_id: z.number().nullable(),
    age_group: z.number().nullable(),
    has_refund: z.boolean(),
  }) satisfies z.ZodType<Omit<Visitor, 'id'>>
).superRefine((data, ctx) => {
  if ((data.total && data.product_ids?.length === 0) || (data.total && !data.product_ids)) {
    ctx.addIssue({
      code: 'custom',
      path: ['product_ids'],
      message:
        'You can not have total value and no products. Please either make total zero, or add products',
    })
  }
})

export type VisitorSchema = z.TypeOf<typeof visitorFormSchema>

export type InventoryModelsMap = Record<string, NonNullable<FetchedInventory>>
